import { Outlet, createRoute } from '@tanstack/react-router'
import { Route as authenticatedRoute } from './route'

interface DocumentSearchParams {
  page?: number;
  size?: number;
  q?: string;
  type?: string;
  vis?: string;
  sort?: string;
  order?: 'asc' | 'desc';
}

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/documents',
  component: () => <Outlet />,
  validateSearch: (search: Record<string, unknown>): DocumentSearchParams => {
    return {
      page: search.page ? Number(search.page) : undefined,
      size: search.size ? Number(search.size) : undefined,
      q: search.q ? String(search.q) : undefined,
      type: search.type ? String(search.type) : undefined,
      vis: search.vis ? String(search.vis) : undefined,
      sort: search.sort ? String(search.sort) : undefined,
      order: search.order === 'desc' ? 'desc' : search.order === 'asc' ? 'asc' : undefined,
    };
  },
})
